import React, { useCallback, useEffect, useState } from "react";
import styles from './index.module.css';
import TableSkeleton from "../../../components/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getAllActiveWinners } from "../../../redux/features/winner/winnerServices";
import Pagination from "../../../components/Pagination";
import { faCalendar, faRefresh, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NoResultsFoundImg from "../../../assets/images/No-resultz-Found.png";
import DatePicker from "react-datepicker";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const Winners = () => {

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { isWinnersLoading, pageCount, winners } = useSelector((state) => state.winner.allActiveWinners);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isDate, setIsDate] = useState(false);
  const [selectedDraw, setSelectedDraw] = useState(null);
  const [isDraw, setIsDraw] = useState(false);
  const [skip, setSkip] = useState(1);

  const fetchWinners = useCallback(
    (filters = {}) => {
      const params = {
        skip: skip,
        limit: 20,
        draw_date: isDate && formatDate(selectedDate),
        draw_no: isDraw && selectedDraw,
        ...filters,
      };
      dispatch(getAllActiveWinners(params));
    },
    [dispatch, skip]
  );

  useEffect(() => {
    fetchWinners();
  }, [fetchWinners]);

  const handlePageChange = (pageNumber) => {
    setSkip(pageNumber);
  };

  const handleSearch = () => {
    const params = {
      skip: skip,
      limit: 25,
      draw_date: isDate && formatDate(selectedDate),
      draw_no: isDraw && selectedDraw,
    };
    dispatch(getAllActiveWinners(params));
  };

  return (
    <div className={styles.resultsContainer}>
      <div className={`main-container`}>
        <div className={`container-content`}>
          <div className={styles.homeHeader}>
            <h1 className={styles.listingTitle}>{t(`WINNERS`)}</h1>
          </div>
          <div className={styles.resultsCardSection}>
            <div className={styles.resultsForm}>
              <div className={styles.searchRow}>
                <div className={styles.dateSec}>
                  <div className={styles.label}>{t(`Date`)}</div>
                  {/* <input
                    type="date"
                    value={selectedDate || ''}
                    onChange={(e) => { setSelectedDate(e.target.value); setSkip(1) }}
                    className={styles.drawInput}
                    placeholder="Draw Date"
                  /> */}
                  <DatePicker
                    showIcon
                    selected={selectedDate}
                    onChange={(date) => { setSelectedDate(date); setIsDate(true);}}
                    icon={faCalendar}
                    className={styles.dateSelector} />
                </div>
                <div className={styles.mobileRow}>
                  <div>
                    <div className={styles.label}>{t(`Draw`)}</div>
                    <input type="text"
                      className={styles.drawInput}
                      placeholder="Draw Number"
                      value={selectedDraw || ''}
                      onChange={(e) => {setSelectedDraw(e.target.value); setIsDraw(true);}} />
                  </div>
                  <div className={styles.btnRow}>
                    <div className={styles.label}></div>
                    <button
                      type="button"
                      className={`${styles.searchBtn} ${i18n.language === 'si' ? `si-text` : i18n.language === 'ta' ? `ta-text` : ""}`}
                      onClick={() => { setSkip(1); handleSearch(); }}
                    >
                      {t(`Search`)}
                    </button>
                    <button type="button" className={styles.searchMobileBtn}
                      onClick={() => { setSkip(1); handleSearch(); }} >
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                    <button
                      type="button"
                      className={styles.resetBtn}
                      onClick={() => {
                        setSelectedDate(new Date());
                        setIsDate(false);
                        setSelectedDraw(null);
                        setIsDraw(false);
                        setSkip(1);
                        fetchWinners();
                      }}
                    >
                      <FontAwesomeIcon icon={faRefresh} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {isWinnersLoading ?
              <TableSkeleton columns={[t(`Username`), t(`Lottery Name`), t(`Date`), t(`Draw`), `${t('Winning Price')} (${t('Rs')})`]} rowCount={10} height={15} />
              :
              winners.length > 0 ?
                <div className={`table-container`}>
                  <table className={`table ${styles.winnersTable}`}>
                    <thead className={`thead ${styles.winnersTableHeader}`}>
                      <tr>
                        <th className={`theadColumnOne ${styles.colOne}`}>{t(`Username`)}</th>
                        <th>{t(`Lottery Name`)}</th>
                        <th>{t(`Date`)}</th>
                        <th>{t(`Draw`)}</th>
                        <th>{t(`Winning Price`)} ({t(`Rs`)})</th>
                      </tr>
                    </thead>
                    <tbody className={`tbody ${styles.winnersTbBody}`}>
                      {winners?.map((ticket) => (
                        <tr key={ticket.id}>
                          <td className={`tdataColumnOne`}>
                            {ticket.user.username}
                          </td>
                          <td>{ticket.lottery.lottery_brand_day.lottery_brand.name}</td>
                          <td>{ticket.lottery.draw_date}</td>
                          <td>{ticket.lottery.draw_no}</td>
                          <td>{ticket.winning_price.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                :
                <div className={styles.noResults}>
                  <img
                    src={NoResultsFoundImg}
                    alt="No Results Found"
                    className={styles.noResultsImage}
                  />
                </div>
            }
          </div>
          <div className={styles.searchCardFooter}>
            {pageCount > 0 && (
              <div className={styles.paginationContainer}>
                <Pagination
                  currentPage={skip}
                  totalPages={pageCount}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Winners;